import report from '@/api/report'

// initial state
const state = {

}


// getters
const getters = {

}

// actions
const actions = {
    saveReport({ commit }, request)
    {
        report.saveReport(response => {
        }, request)
    }
}



// mutations
const mutations = {

}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
